export enum QuestionType {
  OPTION,
  CHECKBOX,
  BOOLEAN,
  SCALE,
  TEXT,
  TEXTAREA,
  SELECT
}
